import { useCallback, useEffect, useState, type MouseEvent, type RefObject } from "react";
import { Maximize2, Minimize2 } from "lucide-react";

export const playerChromeBtnClass =
  "cursor-pointer rounded-md bg-black/35 p-1.5 text-white/55 backdrop-blur transition hover:bg-black/50 hover:text-white/80";

export function PlayerFullscreenButton({
  targetRef,
  className = "",
  floating = true,
}: {
  targetRef: RefObject<HTMLElement | null>;
  className?: string;
  floating?: boolean;
}) {
  const [on, setOn] = useState(false);

  useEffect(() => {
    const sync = () =>
      setOn(Boolean(targetRef.current && document.fullscreenElement === targetRef.current));
    document.addEventListener("fullscreenchange", sync);
    return () => document.removeEventListener("fullscreenchange", sync);
  }, [targetRef]);

  const toggle = useCallback(
    (e: MouseEvent) => {
      e.preventDefault();
      e.stopPropagation();
      const el = targetRef.current;
      if (!el) return;
      if (document.fullscreenElement === el) void document.exitFullscreen();
      else void el.requestFullscreen();
    },
    [targetRef],
  );

  return (
    <button
      type="button"
      onClick={toggle}
      className={
        (floating ? "absolute bottom-2 right-2 " : "") +
        "z-10 " +
        playerChromeBtnClass +
        " " +
        className
      }
      aria-label={on ? "Exit fullscreen" : "Enter fullscreen"}
      title={on ? "Exit fullscreen" : "Fullscreen"}
    >
      {on ? <Minimize2 size={16} strokeWidth={2} /> : <Maximize2 size={16} strokeWidth={2} />}
    </button>
  );
}
